<box>
  <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit($event)"
    (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)" (beforeChange)="beforeChange($event)"
    [style.width]="'100vw'">
    <ng-container *ngIf="selectableList$ | async as selectableList">
      <ng-container *ngFor="let selectableData of selectableList; index as i">
        <box ngxSlickItem [ngClass]="{'slide-checked': formControl.value == selectableData.id}">
          <ng-container [ngTemplateOutlet]="ngTemplateName ? getTemplate(ngTemplateName) : defaultTemplate"
            [ngTemplateOutletContext]="{ $implicit: selectableData, slideIndex: i }">
          </ng-container>
        </box>
      </ng-container>
    </ng-container>
  </ngx-slick-carousel>
</box>

<ng-template #defaultTemplate let-selectableData let-slideIndex="slideIndex">
  <div id="{{ 'slideItem' + selectableData?.id }}" (click)="onClickCard($event, slideIndex, selectableData?.id)"
    [innerHtml]="selectableData?.text.productContent | safeHtml">
  </div>
</ng-template>